import { ReasonsView, useToast } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ElvaSectionState } from '@/components/ElvaSectionState';
import {
  adaptBookingReasonsData,
  adaptPracticeProviders,
  bookingReasonToApi,
} from '../adapters/settingsAdapters';
import { useAppointmentReasons, useUpdateAppointmentReason } from '../hooks/useAppointmentReasons';
import { useProviders } from '../hooks/useProviders';

/** Appointment & booking › Appointment reasons (spec 15 §8). Stage's view on the reasons API. */
export function SettingsAppointmentReasonsPage() {
  const workspaceLabel = useWorkspaceLabel();
  const navigate = useNavigate();
  const { toast } = useToast();
  const reasonsQuery = useAppointmentReasons(true);
  const providersQuery = useProviders(true);
  const updateReason = useUpdateAppointmentReason();

  const serverProviders = providersQuery.data?.providers ?? [];
  const data = useMemo(
    () => adaptBookingReasonsData(reasonsQuery.data?.appointmentReasons ?? [], serverProviders),
    [reasonsQuery.data?.appointmentReasons, serverProviders],
  );
  const roster = useMemo(() => adaptPracticeProviders(serverProviders), [serverProviders]);

  return (
    <ElvaSectionState
      isLoading={reasonsQuery.isLoading || providersQuery.isLoading}
      isError={reasonsQuery.isError}
    >
      <ReasonsView
        data={data}
        providers={roster}
        location={workspaceLabel}
        onOpenTrainElva={() => {
          void navigate('/settings/ai/train');
        }}
        onSaveReason={async (next) => {
          const original = reasonsQuery.data?.appointmentReasons.find((r) => r.id === next.id);
          if (!original) return;
          try {
            await updateReason.mutateAsync({
              id: next.id,
              data: bookingReasonToApi(next, original, serverProviders),
            });
          } catch (err) {
            toast({ title: 'Could not save appointment reason', variant: 'error' });
            throw err;
          }
        }}
      />
    </ElvaSectionState>
  );
}
